(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3HandicapReview', {
            templateUrl: 'app/club-admin/handicap-review/handicap-review.component.html',
            controller: HandicapReviewComponent,
            bindings: {
                clubId: '<',
                data: '<'
            }
        });

    HandicapReviewComponent.$inject = ['$scope', '$locale', 'DataSource', 'Club', 'clubAdminResources', 'user', 'cultureName', 'clubToolsUrl'];
    function HandicapReviewComponent($scope, $locale, DataSource, Club, resources, user, cultureName, clubToolsUrl) {
        var ctrl = this;

        var endOn = new Date();
        var startOn = new Date();
            startOn = subtractYears(startOn, 1);

        // properties
        ctrl.isAssociationAdmin = user.isAssociationAdmin;
        ctrl.dataSource = null;
        ctrl.downloadSource = null;
        ctrl.filter = { startDate: startOn, endDate: endOn, isPrimary: true};
        ctrl.clubId = null;                

        // methods
        ctrl.$onInit = init;
        ctrl.getColumnClass = getColumnClass;
        ctrl.sort = sort;        

        ////////////////////////
        function init() {
            ctrl.dataSource = new DataSource({
                data: ctrl.data,
                read: getData,
                filter: ctrl.filter,
                pageSize: 10,
                params: {
                    id: ctrl.data.clubId
                }
            });


            // Note: the filter change will not trigger a datasource refresh.  It has no change detection other than property setters.
            $scope.$watch('$ctrl.filter', filterWatchAction, true);

        }


        $scope.clickExport = function () {

            if (ctrl.data) {
                Club.getClubHandicapReview({
                    id: ctrl.data.clubId,
                    $orderby: 'lastName asc',
                    $skip: 0,                    
                    $top: ctrl.data.total,
                    $filter: ctrl.filter
                }, true).$promise.then(function (data) {
                    ctrl.downloadSource = new DataSource({
                        data: data,
                        read: getData,
                        filter: ctrl.filter,
                        pageSize: ctrl.data.total,
                        params: {
                            id: ctrl.data.clubId
                        }
                    });

                    $scope.data = {};
                    $scope.data.myInputArray = data.data;
                    setTimeout(function () {
                        document.getElementById("ExportFile").click();
                    }, 1000);

                });
            }
        }

        function subtractYears(date, years) {
            date.setFullYear(date.getFullYear() - years);
            return date;
        }
        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }

        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? { field: field, dir: 'desc' } : null;
        }

        function getData(options) {
            return Club.getClubHandicapReview(options, success, error);

            function success(data) {
                ctrl.data = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.HandicapReviewRequestFailed);
            }
        }

        function getLanguage() {
            return $locale.id === cultureName.fr.toLowerCase() || $locale.id === cultureName.fr_CA.toLowerCase() ? '' : '/en';
        }


        function filterWatchAction(newVal, oldVal) {
            if (oldVal != newVal)
                ctrl.dataSource.page = 1;
        }
    }
})();